import useScrollFade from '../../../hooks/useScrollFade';

const AboutSection = () => {
  const left = useScrollFade();
  const right = useScrollFade({ delay: 150 });

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div ref={left.ref} className={left.fadeClass}>
            <div className="mb-8">
              <h3 className="text-blue-600 text-sm font-bold uppercase tracking-wider mb-3">
                About Us
              </h3>
              <h2 className="text-5xl md:text-6xl font-bold text-gray-900">Built On Experience</h2>
              <div className="flex items-center gap-2 mt-6">
                <div className="h-px w-16 bg-gray-300" />
                <div className="h-0.5 w-10 rounded-full bg-blue-400 shadow-[0_0_8px_rgba(59,130,246,0.6)]" />
                <div className="h-px w-16 bg-gray-300" />
              </div>
            </div>

            <div className="space-y-4 text-gray-600 text-sm leading-relaxed mb-8">
              <p>
                <strong>Top Shelf Solutions</strong> provides fractional CTO leadership, technology strategy, and platform architecture for startups and growing organizations. Founded in 2011 by software industry veteran Larry Schrimpf, the firm helps companies design, build, and scale modern software platforms that support long-term growth.
              </p>
              <p>
                Over the past two decades, Larry has led the development of systems across a wide range of industries, guiding both startups and established companies through critical technology decisions. Many engagements begin with technology strategy, architecture planning, and platform evaluation to ensure systems are built correctly and positioned to scale.
              </p>
              <p>
                Top Shelf Solutions has delivered hundreds of successful technology initiatives, from enterprise platforms supporting thousands of users to specialized systems that power mission-critical internal operations. While some clients engage the firm for fractional CTO leadership and strategic oversight, Top Shelf Solutions can also guide or support the development of custom web, mobile, and cloud-based applications when needed.
              </p>
              <p>
                Every technology decision is guided by a simple principle: <strong>build practical, scalable systems that create measurable business value and move the organization forward.</strong>
              </p>
            </div>

            <div className="bg-gradient-to-r from-gray-100 to-white rounded-xl p-6 border border-gray-200 mb-6">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center relative flex-shrink-0 group">
                  <div className="absolute inset-0 rounded-2xl bg-blue-100 group-hover:bg-blue-50 transition-colors duration-300" />
                  <div className="absolute inset-0 rounded-2xl border-2 border-blue-300 group-hover:border-blue-400 group-hover:shadow-[0_0_12px_rgba(59,130,246,0.3)] transition-all duration-300" />
                  <i className="ri-phone-fill text-2xl text-blue-300 absolute z-10 group-hover:text-blue-400 transition-colors duration-300"></i>
                  <i className="ri-phone-line text-2xl text-blue-600 relative z-20 group-hover:text-blue-700 transition-colors duration-300"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-600 mb-1">Call to ask any question</p>
                  <a
                    href="tel:6023649710"
                    className="text-2xl font-bold text-blue-600 hover:text-blue-700 transition-colors"
                  >
                    602.364.9710
                  </a>
                </div>
              </div>
            </div>

            <button
              onClick={scrollToContact}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-medium transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_20px_rgba(59,130,246,0.45)] whitespace-nowrap cursor-pointer"
            >
              Request A Quote
            </button>
          </div>

          <div ref={right.ref} className={`relative ${right.fadeClass}`}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl w-full h-[520px] border-4 border-blue-100">
              <img
                src="images/ProfilePicture.jpeg"
                alt="Larry Schrimpf - Founder of Top Shelf Solutions"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent px-6 py-5">
                <p className="text-white font-semibold text-lg leading-tight">Larry Schrimpf</p>
                <p className="text-blue-300 text-sm">Founder & Fractional CTO</p>
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-blue-600 rounded-2xl -z-10 opacity-30" />
            <div className="absolute -top-4 -left-4 w-16 h-16 bg-blue-200 rounded-full -z-10 opacity-50" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;